import React, { useEffect, useState } from "react";
import { Modal, Select, message } from "antd";
import { svg } from "../../../../Assets/svg";
import { useAppDispatch, useAppSelector } from "../../../../store";
import {
  AddOrderProductionLogAPI,
  EditOrderProductionLogAPI,
  GetManufacturingProductsListAPI,
  GetOrderProductionLogsAPI,
  GetProductionJobQualityChecklistsAPI,
} from "../../../Redux/orders";
import { GetQualityCheckListAPI } from "../../../Redux/masterData";
import dayjs from "dayjs";
import { BtnLoader } from "../../../../Components/Components";
import FillQualityChecklistModal from "./FillQualityChecklistModal";

const AddOrderProductionQtyModal = ({
  visible,
  setIsModalVisible,
  details,
  selectedLog,
  isDetailsPage,
  // selectedEmployee,
  users,
  setCurrentPage,
  setRerenderLog,
  onSuccess,
}: any) => {
  const selectedEmployee = sessionStorage.getItem("mfg_employee_id") || null;

  const pendingQty = details?.items?.splits?.pending_qty;
  const [qty, setQty] = useState("0");
  const [selectedUser, setSelectedUser] = useState<any>(
    selectedEmployee ? selectedEmployee : null,
  );
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [checklistQuestions, setChecklistQuestions] = useState<any[]>([]);
  const [currentChecklistId, setCurrentChecklistId] = useState<string | null>(
    null,
  );
  const [isHalfComplete, setIsHalfComplete] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const { addOrderProductionLogLoading, editOrderProductionLogLoading } =
    useAppSelector((state: any) => state.loading);
  useEffect(() => {
    if (visible) {
      if (selectedLog) {
        setSelectedUser(selectedLog?.team_member?._id);
        setQty(selectedLog.manufactured_qty.toString());
      } else if (selectedEmployee) {
        setSelectedUser(selectedEmployee);
        setQty("0");
      } else if (details?.items?.splits?.last_log?.team_member?._id) {
        setSelectedUser(details?.items?.splits?.last_log?.team_member?._id);
        setQty("0");
      } else {
        if (users?.length == 1) {
          setSelectedUser(users?.[0]?.value);
        }
        setQty("0");
      }
    }
  }, [selectedLog, visible]);

  const onKeyClick = (key: string) => {
    if (key === "backspace") {
      setQty((prev: string) => (prev.length > 1 ? prev.slice(0, -1) : "0"));
    } else if (qty?.length > 10) {
      message.error("Quantity cannot be greater than 10 digits");
      return;
    } else if (key === ".") {
      if (!qty.includes(".")) {
        setQty((prev: string) => prev + ".");
      }
    } else {
      setQty((prev: string) => (prev === "0" ? key : prev + key));
    }
  };

  const executeSave = (
    manufacturedQty: number,
    checklistAnswers: any = null,
  ) => {
    let quality_checklists: any = undefined;
    if (checklistAnswers) {
      const formattedAnswers = checklistQuestions.map((q: any) => {
        const entry = checklistAnswers[q._id] || {};
        const isQAnswered =
          entry.answer !== null &&
          entry.answer !== undefined &&
          entry.answer !== "";
        return {
          question_id: q._id,
          question_text: q.question_text || "",
          ans_type: q.ans_type || entry.ans_type,
          answer: entry.answer,
          conditional_answer: entry.conditional_answer,
          photo: entry.photo || [],
          photo_required: q.photo_required || false,
          if_yes_action: q.if_yes_action || null,
          if_no_action: q.if_no_action || null,
          is_answered:
            entry.is_answered !== undefined ? entry.is_answered : isQAnswered,
        };
      });

      quality_checklists = [
        {
          checklist_id: currentChecklistId,
          half_complete: isHalfComplete,
          full_complete: !isHalfComplete,
          department_id:
            details?.items?.splits?.department_id?._id ||
            details?.items?.splits?.department_id,
          questions_data: formattedAnswers,
          selected_user: selectedUser,
        },
      ];
    }

    if (selectedLog) {
      const payload: any = {
        log_id: selectedLog?._id,
        manufactured_qty: manufacturedQty,
        diff_qty: manufacturedQty - selectedLog?.manufactured_qty,
        team_member: selectedUser,
        department_id: details?.items?.splits?.department_id,
      };
      if (quality_checklists) payload.quality_checklists = quality_checklists;

      dispatch(
        EditOrderProductionLogAPI(payload, () => {
          message.success("Production log updated successfully");
          setIsModalVisible(false);
          setQty("0");
          setShowChecklistModal(false);
          dispatch({
            type: "ADDED_LOG_FROM_PRODUCTION",
            payload: {
              qty: manufacturedQty - selectedLog?.manufactured_qty,
              id: details?.items?.splits?._id,
            },
          });
          if (isDetailsPage) {
            setRerenderLog?.((prev: any) => prev + 1);
            setCurrentPage?.(1);
          }
          onSuccess?.();
        }),
      );
    } else {
      const payload: any = {
        order_id: details?.order?._id,
        production_planning_id: details?._id,
        splits_id: details?.items?.splits?._id,
        machine_id: details?.items?.splits?.machine_id?._id,
        manufactured_qty: manufacturedQty,
        team_member: selectedUser,
        department_id: details?.items?.splits?.department_id,
      };
      if (quality_checklists) payload.quality_checklists = quality_checklists;

      dispatch(
        AddOrderProductionLogAPI(payload, () => {
          message.success("Production log added successfully");
          setIsModalVisible(false);
          setQty("0");
          setShowChecklistModal(false);
          dispatch({
            type: "ADDED_LOG_FROM_PRODUCTION",
            payload: { qty: manufacturedQty, id: details?.items?.splits?._id },
          });
          if (isDetailsPage) {
            setRerenderLog?.((prev: any) => prev + 1);
            setCurrentPage?.(1);
          }
          onSuccess?.();
        }),
      );
    }
  };

  const onSave = () => {
    if (!selectedUser) {
      message.error("Please select user");
      return;
    }
    const manufacturedQty = parseFloat(qty);
    if (isNaN(manufacturedQty) || manufacturedQty <= 0) {
      message.error("Please enter a valid quantity");
      return;
    }

    const availableQty = selectedLog
      ? pendingQty + selectedLog.manufactured_qty
      : pendingQty;

    if (manufacturedQty > availableQty) {
      message.error(
        `Quantity cannot be greater than available pending quantity (${availableQty})`,
      );
      return;
    }

    const totalQty = Number(details?.items?.quantity || 0);
    const halfQty = totalQty / 2;

    const previousTotal = selectedLog
      ? Number(details?.items?.splits?.total_manufactured_qty || 0) -
        Number(selectedLog.manufactured_qty || 0)
      : Number(details?.items?.splits?.total_manufactured_qty || 0);
    const newTotal = previousTotal + manufacturedQty;
    const departmentId =
      details?.items?.splits?.department_id?._id ||
      details?.items?.splits?.department_id;

    const existingChecklists = details?.items?.splits?.quality_checklists || [];
    const hasHalfComplete = existingChecklists.some(
      (q: any) => q.half_complete === true && q.is_answered === true,
    );
    const hasFullComplete = existingChecklists.some(
      (q: any) => q.full_complete === true && q.is_answered === true,
    );

    let isCrossingHalf =
      totalQty > 0 && newTotal >= halfQty && newTotal != totalQty;
    let isCrossingFull = totalQty > 0 && newTotal >= totalQty;

    if (hasHalfComplete) isCrossingHalf = false;
    if (hasFullComplete) isCrossingFull = false;

    // If they jump straight from < 50% to 100%, and neither is completed yet,
    // we should prioritize full complete (or maybe it asks for half? Let's just ask for full since it overrides).
    const shouldPromptChecklist =
      (isCrossingHalf || isCrossingFull) && departmentId;
    const currentHalfComplete = isCrossingFull ? false : true;

    if (shouldPromptChecklist) {
      const jobId = details?.items?.splits?._id;
      dispatch(
        GetProductionJobQualityChecklistsAPI({ job_id: jobId }, (data: any) => {
          const targetQc = data?.quality_checklists?.find((q: any) =>
            currentHalfComplete
              ? q.half_complete === true
              : q.full_complete === true,
          );
          if (targetQc && targetQc.checklist_id?.questions?.length > 0) {
            setIsHalfComplete(currentHalfComplete);
            setChecklistQuestions(targetQc.checklist_id.questions);
            setCurrentChecklistId(targetQc.checklist_id._id);
            setShowChecklistModal(true);
          } else {
            console.log("No questions found, proceeding to save");
            executeSave(manufacturedQty);
          }
        }),
      );
    } else {
      executeSave(manufacturedQty);
    }
  };

  const onClose = () => {
    setIsModalVisible(false);
    setQty("0");
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={
        <svg
          width={40}
          height={40}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_146_3069)">
            <path
              d="M13.5717 7.47143L11.0074 10L13.5717 12.5286C13.643 12.5954 13.6999 12.6761 13.7388 12.7658C13.7777 12.8555 13.7978 12.9522 13.7978 13.05C13.7978 13.1478 13.7777 13.2445 13.7388 13.3342C13.6999 13.4239 13.643 13.5046 13.5717 13.5714C13.5049 13.6376 13.4258 13.69 13.3388 13.7255C13.2517 13.7611 13.1585 13.7791 13.0645 13.7786C12.8772 13.7778 12.6976 13.7034 12.5645 13.5714L10.0003 11.0071L7.47168 13.5714C7.33864 13.7034 7.15907 13.7778 6.97168 13.7786C6.87768 13.7791 6.78449 13.7611 6.69746 13.7255C6.61044 13.69 6.53128 13.6376 6.46454 13.5714C6.3315 13.4376 6.25683 13.2566 6.25683 13.0679C6.25683 12.8792 6.3315 12.6981 6.46454 12.5643L8.99311 10L6.46454 7.47143C6.34752 7.33479 6.28637 7.15902 6.29332 6.97925C6.30026 6.79948 6.37478 6.62895 6.50199 6.50174C6.6292 6.37453 6.79973 6.30001 6.9795 6.29307C7.15927 6.28612 7.33504 6.34727 7.47168 6.46429L10.0003 8.99286L12.5288 6.46429C12.595 6.39581 12.6739 6.34103 12.7612 6.30308C12.8485 6.26512 12.9424 6.24473 13.0376 6.24307C13.1328 6.24142 13.2274 6.25852 13.3159 6.29341C13.4045 6.3283 13.4853 6.3803 13.5538 6.44643C13.6223 6.51256 13.6771 6.59153 13.715 6.67883C13.753 6.76613 13.7734 6.86005 13.775 6.95523C13.7767 7.05041 13.7596 7.14499 13.7247 7.23356C13.6898 7.32212 13.6378 7.40296 13.5717 7.47143ZM17.0717 17.0714C15.6731 18.4698 13.8913 19.4222 11.9515 19.8079C10.0117 20.1937 8.00111 19.9956 6.1739 19.2387C4.3467 18.4818 2.78498 17.2001 1.68621 15.5556C0.58744 13.9111 0.000976562 11.9778 0.000976562 10C0.000976562 8.02223 0.58744 6.08887 1.68621 4.44441C2.78498 2.79994 4.3467 1.51821 6.1739 0.761307C8.00111 0.00440052 10.0117 -0.193692 11.9515 0.192077C13.8913 0.577846 15.6731 1.53015 17.0717 2.92857C18.0004 3.85717 18.7371 4.95961 19.2397 6.17293C19.7423 7.38625 20.001 8.6867 20.001 10C20.001 11.3133 19.7423 12.6137 19.2397 13.8271C18.7371 15.0404 18.0004 16.1428 17.0717 17.0714ZM16.0645 3.93572C14.8646 2.73996 13.3373 1.92656 11.6754 1.59825C10.0135 1.26993 8.29163 1.4414 6.72714 2.09103C5.16265 2.74065 3.82573 3.83929 2.88521 5.24821C1.94468 6.65713 1.44273 8.31314 1.44273 10.0071C1.44273 11.7011 1.94468 13.3572 2.88521 14.7661C3.82573 16.175 5.16265 17.2736 6.72714 17.9233C8.29163 18.5729 10.0135 18.7444 11.6754 18.416C13.3373 18.0877 14.8646 17.2743 16.0645 16.0786C16.8636 15.2823 17.4976 14.336 17.9303 13.2942C18.3629 12.2523 18.5856 11.1353 18.5856 10.0071C18.5856 8.87902 18.3629 7.762 17.9303 6.72013C17.4976 5.67826 16.8636 4.73203 16.0645 3.93572Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_146_3069">
              <rect width={20} height={20} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      width={"60rem"}
      centered
      className="production-log-modal"
    >
      <div className="modal-content-inner">
        <div className="modal-header-custom d-flex justify-content-between align-items-center p-3">
          {/* <h5 className="title-text mb-0 fw-bold text-center w-100 px-4 mt-5">
            {selectedLog ? "Edit" : "Add"} quantity you have manufacture in this
            slot
          </h5> */}
        </div>
        <div className="page-form select-user-form px-5">
          <div className="form-item" id="product_type">
            <label className="custom-label mb-1 ff fs-1">Select User</label>

            <Select
              size="large"
              className="w-100"
              placeholder="Select User"
              value={selectedUser}
              onChange={(value: any) => setSelectedUser(value)}
              options={users?.length > 0 ? users : []}
              suffixIcon={svg?.selectDownArrow}
              rootClassName="select-user-list-drop"
            />
          </div>
        </div>
        <div className="qty-display-row d-flex align-items-center justify-content-between p-4 px-5">
          <button
            className="btn btn-dark rounded-1 keypad-adjust-btn d-flex align-items-center justify-content-center"
            onClick={() =>
              setQty((prev: string) =>
                Math.max(0, parseFloat(prev) - 1).toString(),
              )
            }
          >
            <span>−</span>
          </button>
          <div className="display-qty fw-bold">{qty}</div>
          <button
            className="btn btn-dark rounded-1 keypad-adjust-btn d-flex align-items-center justify-content-center"
            onClick={() =>
              setQty((prev: string) => (parseFloat(prev) + 1).toString())
            }
          >
            <span>+</span>
          </button>
        </div>

        <div className="keypad-grid border-top">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((kl) => (
            <div
              key={kl}
              className="keypad-item border-end border-bottom text-center cursor-pointer"
              onClick={() => onKeyClick(kl.toString())}
            >
              {kl}
            </div>
          ))}
          <div
            className="keypad-item border-end border-bottom text-center fs-3 cursor-pointer d-flex align-items-center justify-content-center"
            onClick={() => onKeyClick("backspace")}
            style={{ gridColumn: "span 2" }}
          >
            <svg
              width="56"
              height="56"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
              <line x1="18" y1="9" x2="12" y2="15"></line>
              <line x1="12" y1="9" x2="18" y2="15"></line>
            </svg>
          </div>
        </div>

        <button
          className="btn btn-dark w-100 py-3 fs-1 fw-bold rounded-0 text-uppercase tracking-wider py-5"
          onClick={onSave}
          style={{ backgroundColor: "#211f1f", borderColor: "#211f1f" }}
          disabled={
            addOrderProductionLogLoading || editOrderProductionLogLoading
          }
        >
          {addOrderProductionLogLoading || editOrderProductionLogLoading ? (
            <BtnLoader />
          ) : (
            "SAVE"
          )}
        </button>
      </div>

      <FillQualityChecklistModal
        visible={showChecklistModal}
        checklistQuestions={checklistQuestions}
        setIsModalVisible={setShowChecklistModal}
        onOk={(answers: any) => {
          executeSave(parseFloat(qty), answers);
        }}
        isHalfComplete={isHalfComplete}
        loading={addOrderProductionLogLoading || editOrderProductionLogLoading}
      />
      <style>{`
        .title-text {
          font-size: 2.25rem; /* 36px */
        }

        .production-log-modal .ant-modal-content {
          padding: 0 !important;
          overflow: hidden;
          border-radius: 0.75rem; /* 12px */
        }

        .production-log-modal .ant-modal-body {
          padding: 0 !important;
        }

        .keypad-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          background: #fff;
        }

        .keypad-item {
          padding: 1.75rem; /* Kept as is, already rem */
          font-size: 3.4375rem; /* 55px */
          user-select: none;
          transition: background 0.2s;
          border-color: #eee !important;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333;
        }

        .keypad-item:hover {
          background: #f0f0f0;
        }

        .keypad-adjust-btn {
          padding: 3.75rem; /* 60px */
          font-size: 3.4375rem; /* 55px */
          width: 4.375rem; /* 70px */
          height: 3.75rem; /* 60px */
          background-color: #211f1f !important;
          border: none;
        }

        .modal-header-custom {
          position: relative;
          background: #fff;
        }

        .qty-display-row {
          background: #fff;
        }

        .display-qty {
          color: #211f1f;
          font-size: 3.4375rem; /* 55px */
        }
        @media (min-width: 1200px) {
            .keypad-adjust-btn {
                padding: 3rem;
                font-size: 3rem;
                width: 4rem;
                height: 3rem;
            }
            .keypad-item{
              padding: 1rem;
              font-size: 3rem;
            }
            .display-qty{
              font-size: 3rem;
            }
              .fs-1.tracking-wider.py-5{
                font-size: 2rem !important;
                padding-top: 2rem !important;
                padding-bottom: 2rem !important;
              }
              .keypad-item svg  {
                width: 3rem;
                height: 3rem;
              }
        }
        @media (max-width: 575.98px) {
            .keypad-item{
                  padding: 1rem;
                  font-size: 1.75rem;
            }
            .keypad-adjust-btn{
                padding: 1.75rem;
                font-size: 1.4375rem;
                width: 2.375rem;
                height: 1.75rem;
            }
            .qty-display-row.p-4,
              .tracking-wider.py-5 {
                padding: 1rem !important;
            }
            .tracking-wider.fs-1 {
                font-size: 1.5rem !important;
            }
            .qty-display-row.px-5{
                  padding-right: 1rem !important;
              padding-left: 1rem !important;
            }
            .display-qty{
              font-size: 1.75rem;
            }
            .keypad-item svg  {
              width: 1.5rem;
              height: 1.5rem;
            }
          }
      `}</style>
    </Modal>
  );
};

export default AddOrderProductionQtyModal;
